module.exports = __webpack_public_path__ + "static/FSR-A-494cf86bd71319c3fbd283cb6c78627e.jpg";